import EventDispatcher from "../../../../util/EventDispatcher";
import { isNull } from "../../../../util/TypeUtil";
import DialogContentPackage from "../content/DialogContentPackage"
import ScoreMutation from "./ScoreMutation";

export default class DefaultDialogPlayerCommand extends EventDispatcher {
    constructor(languagePack, command, data) {
        super();
        this.languagePack = languagePack;
        this.command = command;
        this._data = data;
    }

    getData() {
        return this._data;
    }

    setData(data) {
        this._data = value;
    }

    setPropertiesFromObject({ command, data }) {
        let dialogContentPackage;
        let numScoreMutations;
        let scoreMutation;

        this.command = command;
        switch (this.command) {
            case DefaultDialogPlayerCommand.CONTENT:
            case DefaultDialogPlayerCommand.OPTION:
                if (isNull(data)) {
                    this._data = null;
                } else {
                    this._data = new DialogContentPackage(this.languagePack);
                    dialogContentPackage = this._data;
                    dialogContentPackage.setPropertiesFromObject(data);
                }
                break;

            case DefaultDialogPlayerCommand.SCORE:
                this._data = [];
                if (Object.prototype.toString.call(data) === '[object Array]') {
                    this._data = [];
                    numScoreMutations = data.length;
                    for (let i = 0; i < numScoreMutations; i++) {
                        scoreMutation = new ScoreMutation("", ScoreMutation.ADD, 0);
                        this._data[i] = scoreMutation;
                    }
                }

                break;

            default:
                this._data = data;
                break;
        }
    }
}


DefaultDialogPlayerCommand.CONTENT = 0;
DefaultDialogPlayerCommand.DELAY = 1;
DefaultDialogPlayerCommand.SCORE = 2;
DefaultDialogPlayerCommand.COMMAND = 3;
DefaultDialogPlayerCommand.OPTION = 4;
